var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAnimationOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 2.16634C2.1562 2.16634 1.98663 2.23658 1.8616 2.3616C1.73658 2.48663 1.66634 2.6562 1.66634 2.83301V12.1663C1.66634 12.3432 1.73658 12.5127 1.8616 12.6377C1.98663 12.7628 2.1562 12.833 2.33301 12.833H4.99967C5.36786 12.833 5.66634 13.1315 5.66634 13.4997C5.66634 13.8679 5.36786 14.1663 4.99967 14.1663H2.33301C1.80257 14.1663 1.29387 13.9556 0.918794 13.5806C0.543722 13.2055 0.333008 12.6968 0.333008 12.1663V2.83301C0.333008 2.30258 0.543721 1.79387 0.918794 1.41879C1.29387 1.04372 1.80258 0.833008 2.33301 0.833008H4.99967C5.36786 0.833008 5.66634 1.13148 5.66634 1.49967C5.66634 1.86786 5.36786 2.16634 4.99967 2.16634H2.33301ZM9.1949 3.69502C9.45525 3.43467 9.87736 3.43467 10.1377 3.69502L13.4634 7.02072C13.5886 7.14191 13.6663 7.31171 13.6663 7.49967C13.6663 7.59261 13.6473 7.6811 13.613 7.76147C13.5805 7.83765 13.5332 7.90901 13.471 7.97116L10.1377 11.3045C9.87736 11.5648 9.45525 11.5648 9.1949 11.3045C8.93455 11.0441 8.93455 10.622 9.1949 10.3617L11.3902 8.16634H4.99967C4.63148 8.16634 4.33301 7.86786 4.33301 7.49967C4.33301 7.13148 4.63148 6.83301 4.99967 6.83301H11.3901L9.1949 4.63783C8.93455 4.37748 8.93455 3.95537 9.1949 3.69502Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAnimationOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-animation-out.29ce4ac06b1583cd69a7545d3e62c2b8.svg";